import script from "./StyleRulesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleRulesManager.vue?vue&type=script&setup=true&lang=js"

import "./StyleRulesManager.vue?vue&type=style&index=0&id=b4c67cc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4c67cc4"]])

export default __exports__